import React from "react";
import { SegmentedControl, SegmentedOption } from "../SegmentedControl";
import TableRowsIcon from "@mui/icons-material/TableRows";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

export type WorklogView = "table" | "calendar";

const OPTIONS: SegmentedOption<WorklogView>[] = [
  { value: "table", label: "Table", icon: <TableRowsIcon sx={{ fontSize: 18 }} /> },
  { value: "calendar", label: "Calendar", icon: <CalendarTodayIcon sx={{ fontSize: 18 }} /> },
];

export const ViewToggle: React.FC<{ value: WorklogView; onChange: (v: WorklogView) => void }> = ({ value, onChange }) => (
  <SegmentedControl<WorklogView> value={value} options={OPTIONS} onChange={onChange} label="View" ariaLabel="Worklog view" compact />
);
